import { ListItemButton, ListItemText } from "@mui/material";
import useDebouncedSearchTerm from "hooks/strings/useDebouncedSearchTerm";
import useGetTransferTrucks from "hooks/organization/useGetTransferTrucks";
import { centsToDollarsInput } from "../worksheetFormValues";
import PickerList from "./PickerList";
import PickerSearch from "./PickerSearch";
import { PickerProps } from "./types";

export default function TransferTruckPicker({ onClose, onSelect }: PickerProps) {
  const { searchTerm, setSearchTerm, debouncedSearchTerm } = useDebouncedSearchTerm("");
  const { data, loading } = useGetTransferTrucks();
  const search = (debouncedSearchTerm ?? "").trim().toLowerCase();
  const trucks = (Array.isArray(data) ? data : []).filter((truck) =>
    String(truck.name ?? "")
      .toLowerCase()
      .includes(search)
  );

  return (
    <PickerList
      title="Select Transfer Truck"
      loading={loading}
      empty={trucks.length === 0}
      header={
        <PickerSearch
          value={searchTerm}
          placeholder="Search transfer trucks"
          onChange={setSearchTerm}
        />
      }
      onClose={onClose}
    >
      {trucks.map((truck) => {
        const hourly = centsToDollarsInput(truck.defaultRateHourly ?? 0);
        const tons = centsToDollarsInput(truck.defaultRateTon ?? 0);

        return (
          <ListItemButton
            key={truck.id}
            onClick={() => {
              onSelect({
                sourceType: "transfer_truck",
                sourceId: truck.id,
                sourceName: truck.name,
                name: truck.name,
                rate: hourly,
                unit: "HOURS",
                quantity: "1",
                truckingUnit: "Hours",
                trucksNeeded: "1",
                truckCapacity: String(truck.defaultTonnage ?? 0),
                truckRateHours: hourly,
                truckRateTons: tons,
              });
              onClose();
            }}
          >
            <ListItemText
              primary={truck.name}
              secondary={`${truck.defaultTonnage ?? 0} US tons · $${hourly}/hr · $${tons}/ton`}
            />
          </ListItemButton>
        );
      })}
    </PickerList>
  );
}
